import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'au',
    conver: 'en-AU',
    alia: 'en',
    region: 'Australia',
    regionText: 'Australia',
    language: 'English',
    languageText: 'English',
    appId: 3,
    acceptLanguage: 'en-AU,en;q=0.9',
};
export default theLocale;
